
import { nextTick, onMounted, Ref, ref, reactive, onBeforeUnmount } from 'vue';

interface IUseTableColumnsSetProps {
  /** 是否启用列设置 */
  enabledVisible?: boolean;
  /** 是否启用列拖拽排序 */
  enabledDrag?: boolean;
  /** 表格渲染的容器 */
  tableRef?: Ref<HTMLElement>;
  /**
   * 操作列的属性名
   * @default 'actions'
   */
  operatorProperty?: string;
}

export const store = reactive({
  operatorProperty: 'actions',
  tableContainer: null as HTMLElement | null,
  enabledVisible: true,
  enabledDrag: false,
  initColumns: () => {},
  hideColumnsSetting: () => {},
  updateVisibleColumns: (keynames?: string[]) => {},
});

/**
 * 表格列设置 （列的显示隐藏 & 列拖拽排序）
 * @returns
 */
export const useTableColumnsSet = (props?: IUseTableColumnsSetProps) => {
  const tableRef = props?.tableRef;

  const operatorProperty = props?.operatorProperty ?? 'actions';
  const enabledVisible = props?.enabledVisible ?? true;
  const enabledDrag = props?.enabledDrag ?? false;

  /** 最终传给table组件的数据 */
  const visibleColumns = ref<string[]>([]);

  function getTableContainer() {
    if (tableRef) {
      return tableRef.value as HTMLElement;
    }

    return document.querySelector('.el-table--fit') as HTMLElement;
  }

  onMounted(() => {
    nextTick(() => {
      if (enabledVisible || enabledDrag) {
        setTimeout(() => {
          const tableContainer = getTableContainer();

          store.enabledDrag = enabledDrag;
          store.enabledVisible = enabledVisible;
          store.tableContainer = tableContainer;
          store.operatorProperty = operatorProperty;

          store.initColumns();
        }, 500);

        store.updateVisibleColumns = (keynames: string[]) => {
          visibleColumns.value = keynames;
        };
      }
    });
  });

  onBeforeUnmount(() => {
    store.hideColumnsSetting();
  });

  return { visibleColumns };
};
